import React from 'react'
import classes from '@src/styles/disposal/trusted-by-clients.module.css'
import TrustedPartner from '@src/assets/landing_page/trusted-partner.svg'
import CaliforniaState from '@src/assets/clients/hero/california-state.svg'
import Trek from '@src/assets/clients/hero/trek.svg'
import Instacart from '@src/assets/clients/hero/instacart.svg'
import SRG from '@src/assets/clients/hero/srg.svg'

export type ClientLogo = { name: string; src: string }

/**
 * "Trusted by 10,000+ clients" hero social-proof card — the §4b element that
 * renders in the hero of every junk-disposal landing page in the source app
 * (PROD-VERIFIED copy + assets from JUNK_REMOVAL_SEO_RESEARCH README §4b).
 * A white card with the "Trusted Partner" badge pinned to the top-right corner,
 * a title, a blurb, and the four hero client logos.
 */
const DEFAULT_CLIENTS: ClientLogo[] = [
  { name: 'California State', src: CaliforniaState.src },
  { name: 'Trek', src: Trek.src },
  { name: 'Instacart', src: Instacart.src },
  { name: 'Sares Regis Group', src: SRG.src },
]

export type TrustedByClientsProps = {
  clients?: ClientLogo[]
  title?: string
  blurb?: string
}

function TrustedByClients({
  clients = DEFAULT_CLIENTS,
  title = 'Trusted by 10,000+ clients',
  blurb = 'Nationwide waste partner for Trek Bikes, Instacart, Sares Regis and more! Trusted by state governments of California, Texas and Connecticut.',
}: TrustedByClientsProps) {
  const logos = clients.filter((c) => c.src)

  return (
    <div className={classes.trustedBlock}>
      <div className={classes.badge}>
        <img src={TrustedPartner.src} alt="Trusted Partner" />
      </div>
      <h3 className={classes.title}>{title}</h3>
      <p className={classes.blurb}>{blurb}</p>
      {logos.length > 0 && (
        <div className={classes.logos}>
          {logos.map(({ name, src }) => (
            <img key={name} className={classes.logo} src={src} alt={`${name} logo`} />
          ))}
        </div>
      )}
    </div>
  )
}

export default TrustedByClients
